<template>
  <div class="provider-contact">
    <a v-if="provider.websiteUrl" :href="provider.websiteUrl" target=”_blank”
        :title="$t('provider.detail.contact.website')"
        :aria-label="$t('provider.detail.contact.website')" class="circle-button">
      <website-icon />
    </a>
    <a v-if="provider.email" :title="$t('provider.detail.contact.email')" :href="emailLink"
        :aria-label="$t('provider.detail.contact.email')" class="circle-button">
      <envelope-icon />
    </a>
    <a v-if="provider.phone" :title="$t('provider.detail.contact.phone')" :href="phoneLink"
        :aria-label="$t('provider.detail.contact.phone')" class="circle-button">
      <phone-icon />
    </a>
  </div>
</template>
<style scoped>
  .provider-contact {
    display: flex;
  }
  .circle-button {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary-color);
  }
  .circle-button:hover {
    background-color: var(--secondary-color);
  }
</style>
<script>
import { ProviderType } from '@/types';
import WebsiteIcon from '../icons/WebsiteIcon.vue';
import EnvelopeIcon from '../icons/EnvelopeIcon.vue';
import PhoneIcon from '../icons/PhoneIcon.vue';

export default {
  name: 'provider-contact',
  props: {
    provider: {
      type: ProviderType,
      required: true,
    },
  },
  computed: {
    emailLink() {
      return `mailto:${this.provider.email}`;
    },
    phoneLink() {
      return `tel:${this.provider.phone}`;
    },
  },
  components: {
    WebsiteIcon,
    EnvelopeIcon,
    PhoneIcon,
  },
};
</script>
